import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=087db5f6&"
import script from "./UploadData.vue?vue&type=script&lang=js&"
export * from "./UploadData.vue?vue&type=script&lang=js&"
import style0 from "./UploadData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports